import { AuthActionType } from './auth-action-type';

export interface ResetPasswordSuccessAction {
  type: AuthActionType.ResetPasswordSuccess;
}

export const resetPasswordSuccess = (): ResetPasswordSuccessAction => ({
  type: AuthActionType.ResetPasswordSuccess,
});
